import {
  CustomEventQueryParams,
  CustomEventsQueryParams,
} from '@nextforce/api'

const keys = {
  all: ['custom_events'],
  list: (params: CustomEventsQueryParams) => [...keys.all, params],
  detail: (params: CustomEventQueryParams) => [...keys.all, params],
}

export default keys
